module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/prh/index.js
// module id = 424
// module chunks = 0